import React from 'react';
import { Button, RouterLink } from '~/shared/components';

interface CategoryLinkProps {
    url: string;
    name: string;
}

export const MobileCategoryLink = ({ url, name }: CategoryLinkProps) => {
    return (
        <RouterLink prefetch={false} href={url}>
            <Button
                as="a"
                href={url}
                title={name}
                variant="secondary"
                size="sm"
                rounded
                shape="icon"
            >
                {name}
            </Button>
        </RouterLink>
    );
};
